export default function compileInvalidFormField(element) {
  const inputGroup = element.closest('.input-group')
  const formGroup = element.closest('.form-group')

  function setInputGroupInvalid(isInvalid) {
    inputGroup?.classList?.toggle('is-invalid', isInvalid)
  }

  function unsetOtherFormGroupFieldsInvalid() {
    if (formGroup) {
      Array.from(formGroup.querySelectorAll('.is-invalid')).forEach((element) => {
        element.classList.remove('is-invalid')
      })
      formGroup.querySelector('.invalid-feedback.d-block')?.classList?.remove('d-block')
    }
  }

  function setDatePickerFieldInvalid(isInvalid) {
    if (element.datePickerInput) {
      element.datePickerInput.classList.toggle('is-invalid', isInvalid)
    }
  }

  function setInvalidFeedback(isInvalid) {
    if (!formGroup) return

    const feedbackElement = formGroup.querySelector('.invalid-feedback') || up.element.affix(formGroup, '.invalid-feedback')

    if (!isInvalid) {
      element.removeAttribute('data-invalid-feedback')
      feedbackElement.remove()
      return
    }

    const invalidFeedback = element.dataset.invalidFeedback?.split('\n')
    invalidFeedback?.forEach((feedback) => {
      if (!feedbackElement.textContent.includes(feedback)) {
        feedbackElement.textContent += `\n${feedback}`
      }
    })
  }

  function unsetInvalid() {
    element.classList.remove('is-invalid')
    unsetOtherFormGroupFieldsInvalid()
    setInputGroupInvalid(false)
    setDatePickerFieldInvalid(false)
    setInvalidFeedback(false)
  }

  setInputGroupInvalid(true)
  setDatePickerFieldInvalid(true)
  setInvalidFeedback(true)
  up.on(element, 'input change', unsetInvalid, { once: true })
}
